module.exports = __webpack_public_path__ + "static/img/1-2-4.b687c415.jpg";